import React from 'react';
import LoadingComponent from '../commonComponents/LoadingComponent';

function withLoader(WrappedComponent) {
  return function component(props) {

    if (props.isLoading) {
      return (
        <>
          <WrappedComponent {...props} />
          <LoadingComponent />
        </>
      );
    }
    return <WrappedComponent {...props} />;
  };
}

export default withLoader;
